import { IonInput, IonItem, IonLabel, IonNote } from '@ionic/react'
import Button from '../../../components/Button'
import { useEffect, useState } from 'react'
import useValidate from '../../../hooks/useValidate'
import { useStepsContext } from '../../../context/StepsContext'
import useRequests from '../../../hooks/useRequests'
import { useDispatch } from 'react-redux'
import { COMPLETE_INPUT } from '../../../redux/actions'

const initialState = {
  lineNumber: '',
  emailOptional: ''
}

const LineValidation = () => {
  const { setNewProcedureStep, inProcess }: any = useStepsContext()
  const [error, setError] = useState(initialState)
  const [input, setInput]: any = useState(initialState)
  const dispatch = useDispatch()

  const { validateLine } = useRequests('nomLineForm')

  useEffect(() => {
    setInput(initialState)
    setError(initialState)
  }, [inProcess])

  const { validate } = useValidate()
  const handleChange = (event: any) => {
    const currentValue = event.detail.value
    const errorOnValidaty = validate(currentValue, event.target.name)
    setInput({ ...input, [event.target.name]: currentValue })
    if (!errorOnValidaty) setError({ ...error, [event.target.name]: '' })
  }
  const handleError = (event: any) => {
    const inputName = event.target.name
    const errorOnValidaty = validate(input[event.target.name], inputName)
    if (errorOnValidaty) {
      setError({ ...error, [inputName]: errorOnValidaty })
      event.target.parentNode.parentNode.classList.add('error')
    }
  }
  const clearError = (event: any) => {
    const inputName = event.target.name
    setError({ ...error, [inputName]: '' })
    event.target.parentNode.parentNode.classList.remove('error')
  }
  const onContinue = async () => {
    dispatch({
      type: COMPLETE_INPUT,
      payload: { storeForm: 'nomLineForm', name: 'lineNumber', value: input.lineNumber }
    })
    input.emailOptional &&
      dispatch({
        type: COMPLETE_INPUT,
        payload: { storeForm: 'nomLineForm', name: 'emailOptional', value: input.emailOptional }
      })
    const response = await validateLine(input.lineNumber)
    if (!response.flagLevantaPresusp) return
    setNewProcedureStep(2)
  }

  const validity = input.lineNumber && input.lineNumber.length === 10 && !error.lineNumber && !error.emailOptional
  return (
    <main className="form">
      <div className="form-container">
        <h2 className="form-title">
          Completá los datos para <br /> validar la línea
        </h2>
        <IonItem shape="round">
          <IonLabel position="floating">Número de línea preactiva</IonLabel>
          <IonInput
            id="numero-linea-preactiva"
            name="lineNumber"
            value={input.lineNumber}
            inputMode="numeric"
            type="text"
            minlength={10}
            maxlength={10}
            autocomplete="off"
            onIonChange={handleChange}
            onFocus={clearError}
            onBlur={handleError}
          ></IonInput>
        </IonItem>
        {!error.lineNumber ? (
          <IonNote className={`input-info`}>Ingresarlo sin el 0 y sin el 15</IonNote>
        ) : (
          <span className="input-error">{error.lineNumber}</span>
        )}

        <IonItem shape="round">
          <IonLabel position="floating">Correo electrónico (Opcional)</IonLabel>
          <IonInput
            id="pin-verificador-ion-input-pin"
            name="emailOptional"
            value={input.emailOptional}
            inputMode="email"
            type="email"
            minlength={10}
            maxlength={50}
            autocomplete="off"
            onIonChange={handleChange}
            onFocus={clearError}
            onBlur={handleError}
          ></IonInput>
        </IonItem>
        {!error.emailOptional ? (
          <IonNote className={`input-info large-note`}>
            Recordarle al cliente que puede retirar su documentación en un Centro de Atención de Claro
          </IonNote>
        ) : (
          <span className="input-error">{error.emailOptional}</span>
        )}
      </div>
      <div className="form-bottom-buttons">
        <Button
          id="validate-line-continue"
          label="Continuar"
          className="submit-button"
          validity={!validity}
          handleSubmit={onContinue}
        />
      </div>
    </main>
  )
}

export default LineValidation
